;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="df8cad10-3723-4c2a-aaad-83f3242822ba",e._sentryDebugIdIdentifier="sentry-dbid-df8cad10-3723-4c2a-aaad-83f3242822ba")}catch(e){}}();var _global =
      typeof window !== 'undefined' ?
        window :
        typeof global !== 'undefined' ?
          global :
          typeof self !== 'undefined' ?
            self :
            {};

    _global.SENTRY_RELEASE={id:"3.32.0"};
//# sourceMappingURL=_sentry-release-injection-file.js.map
